var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStopSign = function SvgStopSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 313 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.2917 313L0 221.708V91.2917L91.2917 0H221.708L313 91.2917V221.708L221.708 313H91.2917ZM106.942 230.403L156.5 180.844L206.058 230.403L230.403 206.058L180.844 156.5L230.403 106.942L206.058 82.5972L156.5 132.156L106.942 82.5972L82.5972 106.942L132.156 156.5L82.5972 206.058L106.942 230.403ZM106.072 278.222H206.928L278.222 206.928V106.072L206.928 34.7778H106.072L34.7778 106.072V206.928L106.072 278.222Z",
    fill: "#DF2020"
  })));
};
export { SvgStopSign as ReactComponent };
export default __webpack_public_path__ + "assets/3e5b0ae7.svg";